export default "__VITE_ASSET__DkqqUSBD__"